import React, { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { PVMUrls } from 'config/urls';

const errorMessage: string = 'Something went wrong!';

interface outputType {
    data: any;
    loading: boolean;
    error: any;
}

// common api handler
function useFetchPlansDropdownValues({ setComparisonValue }: any): outputType {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);

    // Queries
    const {
        data: apiData,
        isFetching,
        isSuccess,
        fetchStatus,
        error: apiError,
    } = useQuery<any, any>({
        queryKey: ['pvm-plans-dropdown-values'],
        queryFn: async () => {
            //initializing states
            setData(null);
            setError(null);
            setLoading(true);
            try {
                const data = await axios({
                    method: 'get',
                    url: PVMUrls.PlansDropdownUrl,
                    params: { feature_name: 'pvm' },
                });
                return data;
            } catch (error) {
                console.log('err ', error);
                onFetchError(error);
            }
        },
        //  enabled: false,
    });

    const apiLoading = isFetching || fetchStatus === 'paused';
    const apiSuccess = !apiLoading && !apiError && isSuccess;

    //error handling
    if (!apiLoading && apiError && !error) {
        onFetchError(apiError);
    }
    useEffect(() => {
        //success handling
        if (apiSuccess && apiData?.data) {
            if (error) setError(null);
            onFetchComplete(apiData.data);
        }
    }, [apiData?.data, apiSuccess]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const parsedData: any = [];

            payload?.forEach((item: any) => {
                const label =
                    item[0].toUpperCase().replace(/_/g, ' ') + ' vs ' + item[1].toUpperCase().replace(/_/g, ' ');
                const i: any = {
                    value: label,
                    label: label,
                    apiParam: item,
                };

                parsedData.push(i);
            });

            setComparisonValue(parsedData[0]);

            setData(parsedData);
        } catch (error) {
            onFetchError(error);
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }
    const outputData: outputType = {
        loading,
        error,
        data,
    };
    return outputData;
}

export { useFetchPlansDropdownValues };
